import { Form } from "../Abstracts/Form";
import { EntityModalForm } from "../CRUDs/abstracts/mixins/EntityModalForm";
import { Preloader } from "../Common/Preloader";
import { Signature } from "../Common/Signature";

export const ApproveQuoteForm = (() => {

    return class ApproveQuoteForm extends Form {

        constructor(quote) {
            super('approve-quote-modal', `/customer/quote/${quote.id}/accept`, 'POST');

            this.quote = quote;
            this.formContainer = document.querySelector('#form-container');
            this.submitBtn = this.formContainer.querySelector('#approve.accept');

            const hasSignature = this.submitBtn.hasAttribute('data-has-signature');
            this.getSignatureData = Signature.init(hasSignature, {width: 396, height: 190});

            this.listners();
        }

        showSignature() {
            $('#approve-quote-modal').modal('hide');
            $('#signature-modal').modal('show');
        }

        async submit() {
            const signature = this.getSignatureData();
            $('#signature-empty-error').addClass('d-none')
            if(signature === false){
                $('#signature-empty-error').removeClass('d-none')
                setTimeout(()=>{
                    $('#signature-empty-error').addClass('d-none')
                },3000)
                return
            }

            const result = await fetch(this.actionUrl, {
                method: this.method,
                body: JSON.stringify({ signature }),
                headers: { 'Content-Type': 'application/json' }
            });

            const preloader = new Preloader('signature-modal', true);
            preloader.setMessage('Processing');
            preloader.open();

            if (result.ok) this.successCallback(result);
            else this.errorCallback(result);
        }

        async successCallback(result) {
            const formHTML = await result.json();
            $('#signature-modal').modal('hide');
            $('.modal-backdrop').first().remove();

            EntityModalForm.pasteForm(formHTML.modal);
            $('#success-action-modal').modal('show');
            $('.modal').modal('hide');
        }

        async errorCallback(result) {
            $('.modal').modal('hide');
        }

        listners() {
            super.listners()
            this.formContainer.querySelector('#signature-required')?.addEventListener('click', this.showSignature);
            this.formContainer.querySelector('[data-reject]').addEventListener('click', () => {
                const formHTML = this.quote.getForm(this.quote.entityClass, 'reject', this.quote.id);
                $(this.formContainer).append(formHTML);
   

                const confirmModal = $(this.formContainer).find('#confirm-action-modal');

                confirmModal
                    .modal('show')
                    .find('button[data-confirmation]')
                    .on('click', (e) => {
                        this.quote.changeStatus('rejected');
                        confirmModal.modal('hide');
                        $('#approve-quote-modal').modal('hide');
                        window.location.reload();
                    });
            });
        }

        static init(quote) {
            const quoteData = quote.read();
            let flag = false;
            const statusList = quote.getStatusList();
            if (quoteData.status == statusList.waiting_approval || quoteData.status == statusList.draft) {
                flag = true;
            }
            if (flag) {
                quote.openModal('approve');
                return new ApproveQuoteForm(quote);
            }
        }
    }

})();
